import { Sprite, Texture, Graphics, Text, TextMetrics } from "pixi.js";
import { GameConfigs } from "../../lib/globals/GameConfigs";
import { formatCurrencyValue, getCurrencySymbol } from "../helper/currencies";
import { EVENTS } from "../../lib/constants";
import QuestData from "./helper/getQuestData";
import { items } from "./helper/Items";

class QuestItemController {
  constructor(vc, conf) {
    this.config = conf;
    this.all_quest = QuestData.processQuest(GameConfigs.quest);
    this.quest_data = this.all_quest.items[this.config.id - 1];
    this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
    this.positions = {
      width: window.isMobile || window.isTablet ? 317 : 317,
      x: window.isMobile || window.isTablet ? 140 : 140,
      y: window.isMobile || window.isTablet ? 80 : 80,
    };
    if (vc.getChildByName(this.config.item, true)) {
      this.vc = vc.getChildByName(this.config.item, true);
      this.generateItemData(this.quest_data);
      this.init();
      window.addEventListener(EVENTS.SERVER_MSG, this, false);
      window.addEventListener(EVENTS.MODAL, this, false);
    } else {
      throw new Error(
        "QuestItemController failed init " + JSON.stringify(this.config)
      );
    }
  }

  handleEvent(evt) {
    switch (evt.type) {
      case EVENTS.SERVER_MSG:
        if (evt.detail.service === "quest") {
          this.all_quest = QuestData.processQuest(GameConfigs.quest);
          this.quest_data = this.all_quest.items[this.config.id - 1];
          this.quest_data.progress =
            evt.detail.data.progresses[this.config.id - 1];
          this.quest_data.item.isCompleted =
            evt.detail.data.progresses[this.config.id - 1] >=
            this.quest_data.item.count;
          this.checkComplete(this.quest_data.item.isCompleted);
        }
        break;
      case EVENTS.MODAL:
        if (evt.detail.modal !== "quest") {
          window.removeEventListener(EVENTS.SERVER_MSG, this, false);
          window.removeEventListener(EVENTS.MODAL, this, false);
        }
        break;
      default:
        break;
    }
  }

  checkComplete(completed) {
    if (completed) {
      this.vc.itemprogresstext.text = "COMPLETED";
      this.drawRectangle(
        this.vc.itemprogressresult,
        this.positions.x,
        this.positions.y,
        this.positions.width,
        16,
        0.3 * this.positions.width
      );
    } else {
      this.updateProgress();
    }
  }

  init() {
    this.vc.itemprogress = new Graphics();
    this.vc.itemprogress.clear();
    this.vc.itemprogress.beginFill(0x0d3548);
    this.vc.itemprogress.drawRoundedRect(
      this.positions.x,
      this.positions.y,
      this.positions.width,
      16,
      12
    );
    this.vc.itemprogresstext = new Text("", {
      fontSize: 14,
      fontFamily: "Poppins SemiBold",
      fill:
        this.quest_data.item.count / this.quest_data.progress < 2
          ? "#230E35"
          : "#DEE0EF",
    });
    this.vc.itemprogressresult = new Graphics();
    this.initPositions();
    this.checkComplete(this.quest_data.isCompleted);
  }

  initPositions() {
    this.vc.itemimg.position.x = 6;
    this.vc.itemimg.position.y = 6;
    this.vc.itemprogresstext.anchor.x = 0.5;
    this.vc.itemprogresstext.position.x =
      this.positions.x + this.vc.itemprogress.getBounds().width / 2;
    this.vc.itemprogresstext.y = 80;
    this.vc.addChild(this.vc.itemprogress);
    this.vc.itemprogress.addChild(this.vc.itemprogressresult);
    this.vc.itemprogress.addChild(this.vc.itemprogresstext);
  }

  drawRectangle(vc, x, y, w, h, r) {
    vc.clear();
    vc.beginFill(
      this.quest_data.progress >= this.quest_data.item.count
        ? 0xa2af50
        : 0xe5a7dd
    );
    vc.drawRoundedRect(x, y, w, h, r);
  }

  updateProgress() {
    if (this.quest_data.isCompleted) return;
    this.vc.itemprogresstext.style.fill =
      this.quest_data.item.count / this.quest_data.progress < 2
        ? "#230E35"
        : "#DEE0EF";
    this.vc.itemprogresstext.text =
      this.quest_data.progress + "/" + this.quest_data.item.count;
    this.drawRectangle(
      this.vc.itemprogressresult,
      this.positions.x,
      this.positions.y,
      (this.positions.width / this.quest_data.item.count) *
        this.quest_data.progress,
      16,
      0.3 *
        ((this.positions.width / this.quest_data.item.count) *
          this.quest_data.progress)
    );
  }

  capitalizeWords(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  generateItemData(data) {
    this.generateItem(data);
    this.generatePrize(data);
  }

  generateItem(data) {
    switch (data.item.type) {
      case "line_count":
        this.vc.itemimg = new Sprite(
          Texture.from(items[data.item.config.item_id].img)
        );
        this.vc.addChild(this.vc.itemimg);
        this.vc.itemheader.text = `Catch ${data.item.config.count}x ${items[data.item.config.item_id].name} Symbol`;
        break;
      case "total_count":
        this.vc.itemimg = new Sprite(Texture.from("quest_scatter"));
        this.vc.addChild(this.vc.itemimg);
        this.vc.itemheader.text = `Catch Min. ${data.item.config.count}x ${items[data.item.config.item_id].name}`;
        break;
      case "coeff":
        this.vc.itemimg = new Sprite(Texture.from("quest_star"));
        this.vc.addChild(this.vc.itemimg);
        this.vc.itemheader.text = `Catch +${data.item.config.coeff}x Multiplier`;
        break;
      case "wager":
        this.vc.itemimg = new Sprite(Texture.from("quest_coin"));
        this.vc.addChild(this.vc.itemimg);
        this.vc.itemheader.text = `Spin ${formatCurrencyValue(GameConfigs.config.bet_steps[data.item.config.bet_level], this.currency, GameConfigs.config.currency_prec)}+ Bet Amount`;
        break;
      default:
        break;
    }
    const item_header_coeff = TextMetrics.measureText(
      this.vc.itemheader.text,
      this.vc.itemheader.style
    );
    if (item_header_coeff.width > 330) {
      this.vc.itemheader.style.fontSize = 20;
    } else {
      this.vc.itemheader.style.fontSize = 24;
    }
  }

  generatePrize(data) {
    let prize = data.prize;
    let prizeType = this.capitalizeWords(prize.type.split("_").join(" "));

    const setTextAndMeasure = (subtitleText, descText) => {
      this.vc.itemsubtitle.text = subtitleText;
      this.vc.itemdesc.text = descText;
      const metrics = TextMetrics.measureText(
        this.vc.itemsubtitle.text,
        this.vc.itemsubtitle.style
      );
      this.vc.itemdesc.x = 175 + metrics.width;
    };

    switch (prize.type) {
      case "bonus_discount":
      case "bet_discount":
        setTextAndMeasure(
          "Bet Relevant",
          `${prize.config.discount}% ${prizeType}`
        );
        break;
      case "bonus_game":
        setTextAndMeasure("Bet Relevant Free", prizeType);
        break;
      case "win_multiplier":
        setTextAndMeasure(
          "Bet Relevant",
          `${prize.config.multiplier}X ${prizeType}`
        );
        break;
      case "wild_respin":
        setTextAndMeasure(
          "Bet Relevant",
          `${prize.config.wilds}x ${prizeType}`
        );
        break;
      default:
        break;
    }
  }
}

export default QuestItemController;
